module.exports = __webpack_public_path__ + "static/img/arinkel-1.e1c18ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/arinkel-1.jpg
// module id = F0E7
// module chunks = 1